import React from 'react';
import { Modal, ModalFooter } from '@/components/common';
import { InstitutionDTO } from '@/models';

interface InstitutionDeleteModalProps {
  isOpen: boolean;
  institution: InstitutionDTO | null;
  isSaving: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export const InstitutionDeleteModal: React.FC<InstitutionDeleteModalProps> = ({
  isOpen,
  institution,
  isSaving,
  onConfirm,
  onClose,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnBackdropClick={false}
      title="Delete Institution"
      footer={
        <ModalFooter
          onCancel={onClose}
          onConfirm={onConfirm}
          confirmText="Delete"
          confirmVariant="danger"
          isLoading={isSaving}
        />
      }
    >
      <p>
        Are you sure you want to delete institution <strong>{institution?.name}</strong>?
        This action cannot be undone.
      </p>
    </Modal>
  );
};
